export const company = {
  name: "SBRGREEN CONSTRUCTION PRIVATE LIMITED",
  shortName: "SBRGREEN",
  tagline: "Building lasting structures. Growing greener futures.",
  phone: "+91 98765 43210",
  email: "info@sbrgreen.com",
  address: "Plot 42, Green Tech Park, Sector 18, Gurugram, Haryana 122001",
  hours: "Mon – Sat: 9:00 AM – 6:00 PM",
};

export const navLinks = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About" },
  { path: "/services", label: "Services" },
  { path: "/projects", label: "Projects" },
  { path: "/gallery", label: "Gallery" },
  { path: "/careers", label: "Careers" },
  { path: "/contact", label: "Contact" },
];

export const services = [
  {
    id: "structural-building",
    title: "Structural Building Works",
    summary:
      "Complete structural building construction for durable, code-compliant structures.",
    details:
      "We execute structural building works with accurate detailing, quality materials, and strict site supervision from framing to structural completion.",
  },
  {
    id: "foundation-work",
    title: "Foundation Work",
    summary:
      "Strong, engineered foundations that support safe and long-lasting construction.",
    details:
      "Our foundation services cover excavation, footing, raft, and related substructure works with careful soil handling and quality concrete practices.",
  },
  {
    id: "site-development",
    title: "Site Development",
    summary:
      "End-to-end site preparation and development for ready-to-build project grounds.",
    details:
      "From leveling and grading to access roads and utility-ready plots, we prepare sites for smooth and efficient construction progress.",
  },
  {
    id: "piling-work",
    title: "Piling Work",
    summary:
      "Reliable piling solutions for deep foundations and high-load structures.",
    details:
      "We deliver piling work with controlled installation methods, alignment checks, and load-ready foundations for industrial and commercial projects.",
  },
  {
    id: "industrial-projects",
    title: "Industrial Projects",
    summary:
      "Industrial sheds, plants, and utility structures built for performance and scale.",
    details:
      "Our industrial project teams focus on functional layouts, strong structures, and efficient execution for manufacturing and warehouse facilities.",
  },
  {
    id: "bridge-structural",
    title: "Bridge Structural Works",
    summary:
      "Structural construction support for bridges and related civil structures.",
    details:
      "We undertake bridge structural works with disciplined engineering coordination, formwork quality, and durable concrete and steel practices.",
  },
  {
    id: "road-design-construction",
    title: "Road Design & Construction",
    summary:
      "Practical road design and construction for internal and connecting road networks.",
    details:
      "We plan and build roads with proper alignment, drainage consideration, compaction standards, and lasting pavement quality.",
  },
  {
    id: "fabrication-works",
    title: "Fabrication Works",
    summary:
      "Steel and metal fabrication for structural and site construction needs.",
    details:
      "Our fabrication works include cutting, assembly, and installation support for structural steel, frames, and custom site components.",
  },
  {
    id: "interior-works",
    title: "Interior Works",
    summary:
      "Interior fit-outs and finishing that complete functional, presentable spaces.",
    details:
      "We deliver interior works covering partitions, finishes, and related installations with clean workmanship and coordinated site delivery.",
  },
  {
    id: "fencing-boundary",
    title: "Fencing & Boundary Works",
    summary:
      "Secure fencing and boundary solutions for project sites and properties.",
    details:
      "We install fencing and boundary systems that improve site security, define property limits, and withstand outdoor conditions.",
  },
  {
    id: "boundary-wall",
    title: "Boundary Wall Construction",
    summary:
      "Strong boundary walls designed for security, durability, and neat finishing.",
    details:
      "Our boundary wall construction covers layout marking, masonry or RCC options, and finishing suitable for residential and commercial sites.",
  },
  {
    id: "rcc-boundary",
    title: "RCC Boundary Work",
    summary:
      "Reinforced cement concrete boundary structures for long-term strength.",
    details:
      "We execute RCC boundary work with proper reinforcement, formwork, and curing practices for durable perimeter structures.",
  },
  {
    id: "rcc-drain",
    title: "RCC Drain Work",
    summary:
      "RCC drain construction for effective site and roadside water management.",
    details:
      "Our RCC drain works help control stormwater flow with accurate levels, strong concrete sections, and clean finishing.",
  },
  {
    id: "commercial-building",
    title: "Commercial Building Projects",
    summary:
      "Offices, retail, and commercial buildings delivered with professional project control.",
    details:
      "We build commercial projects with attention to structure, schedule, safety, and finishes that support business-ready spaces.",
  },
  {
    id: "general-construction",
    title: "General Construction Services",
    summary:
      "Any construction-related work handled with skilled teams and clear delivery.",
    details:
      "From specialized civil packages to complete project support, SBRGREEN undertakes construction-related works tailored to your site requirements.",
  },
];

export const projects = [
  {
    id: 1,
    title: "Verdant Heights Residences",
    category: "Residential",
    location: "Gurugram",
    year: "2025",
    status: "Completed",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80",
    description:
      "A mid-rise residential complex with landscaped courtyards and energy-efficient façades.",
  },
  {
    id: 2,
    title: "Northline Business Hub",
    category: "Commercial",
    location: "Noida",
    year: "2024",
    status: "Completed",
    image:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=80",
    description:
      "Multi-tenant office campus with flexible floor plates and structured parking.",
  },
  {
    id: 3,
    title: "Riverbend Civic Corridor",
    category: "Infrastructure",
    location: "Faridabad",
    year: "2025",
    status: "Ongoing",
    image:
      "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1200&q=80",
    description:
      "Road widening, stormwater drainage, and pedestrian pathway upgrades along a key corridor.",
  },
  {
    id: 4,
    title: "Cedar Grove Villas",
    category: "Residential",
    location: "Greater Noida",
    year: "2023",
    status: "Completed",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80",
    description:
      "Premium villa community emphasizing natural light, open plans, and durable finishes.",
  },
  {
    id: 5,
    title: "Apex Industrial Sheds",
    category: "Industrial",
    location: "Bhiwadi",
    year: "2024",
    status: "Completed",
    image:
      "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1200&q=80",
    description:
      "Pre-engineered industrial units with high clear heights and efficient logistics access.",
  },
  {
    id: 6,
    title: "Greenleaf School Campus",
    category: "Institutional",
    location: "Gurugram",
    year: "2026",
    status: "Ongoing",
    image:
      "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=80",
    description:
      "Educational campus featuring classrooms, sports courts, and landscape-led site planning.",
  },
];

export const galleryImages = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1000&q=80",
    alt: "Steel frame rising on a commercial site",
    caption: "Structural frame — Northline Hub",
  },
  {
    id: 2,
    src: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1000&q=80",
    alt: "Workers on an active construction site",
    caption: "On-site coordination",
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1000&q=80",
    alt: "Crane and building under construction",
    caption: "Vertical construction progress",
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1000&q=80",
    alt: "Modern completed glass building",
    caption: "Completed commercial façade",
  },
  {
    id: 5,
    src: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1000&q=80",
    alt: "Modern residential home exterior",
    caption: "Residential finishing",
  },
  {
    id: 6,
    src: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1000&q=80",
    alt: "Industrial construction interior",
    caption: "Industrial shell works",
  },
  {
    id: 7,
    src: "https://images.unsplash.com/photo-1590644365607-1c5a08109165?auto=format&fit=crop&w=1000&q=80",
    alt: "Concrete pouring at foundation",
    caption: "Foundation & concrete works",
  },
  {
    id: 8,
    src: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?auto=format&fit=crop&w=1000&q=80",
    alt: "Blueprint and hard hat on site table",
    caption: "Planning & quality checks",
  },
];

export const testimonials = [
  {
    quote:
      "SBRGREEN delivered our campus on schedule with exceptional site discipline. Communication was clear at every milestone.",
    name: "Ananya Mehta",
    role: "Director, Greenleaf Education Trust",
  },
  {
    quote:
      "Their green-building approach reduced long-term operating costs without compromising design quality.",
    name: "Rohan Kapoor",
    role: "CEO, Northline Realty",
  },
  {
    quote:
      "From excavation to handover, the team was professional, safety-focused, and easy to work with.",
    name: "Priya Sharma",
    role: "Homeowner, Cedar Grove",
  },
];

export const values = [
  {
    title: "Safety First",
    text: "Every site follows strict safety protocols — protecting people, schedules, and outcomes.",
  },
  {
    title: "Craft & Quality",
    text: "We build with care: accurate detailing, durable materials, and thorough inspections.",
  },
  {
    title: "Green Responsibility",
    text: "Sustainable choices are part of how we plan, source, and deliver every project.",
  },
  {
    title: "Transparent Delivery",
    text: "Clear timelines, honest reporting, and accountable project leadership.",
  },
];

export const milestones = [
  { value: "15+", label: "Years of experience" },
  { value: "120+", label: "Projects delivered" },
  { value: "80+", label: "Skilled professionals" },
  { value: "98%", label: "Client satisfaction" },
];

export const careers = [
  {
    title: "Project Engineer",
    type: "Full-time",
    location: "Gurugram",
    summary:
      "Coordinate site execution, track progress against drawings, and support quality control.",
  },
  {
    title: "Site Supervisor",
    type: "Full-time",
    location: "NCR Sites",
    summary:
      "Lead daily workforce activities, enforce safety standards, and maintain site documentation.",
  },
  {
    title: "Quantity Surveyor",
    type: "Full-time",
    location: "Gurugram HQ",
    summary:
      "Prepare BOQs, monitor material usage, and support cost control across active projects.",
  },
  {
    title: "Safety Officer",
    type: "Full-time",
    location: "Multiple Sites",
    summary:
      "Implement HSE policies, conduct toolbox talks, and ensure regulatory compliance on site.",
  },
];
